import RwdAdvocacy from 'components/Campaigns/RwdAdvocacy/RwdAdvocacy';
import { withRwdAdvocacyProps } from 'viewModel/Campaigns/RwdAdvocacy/withRwdAdvocacyProps';

export default withRwdAdvocacyProps(RwdAdvocacy);
